<template>
  <div class="main">
    <div class="top">
      <img src="../../assets/img/checkPoint/head@2x.png" alt="" class="hand_img">
      <span>携康科技在线下布局健康检测点<br />为公众提供免费检测服务</span>
    </div>
    <div class="bgBox">
      <div class="bottom" @click="onHerf">查看检测点</div>
    </div>
  </div>
</template>
<script>
import {
  removeParams,
  removeUser,
  getToken,
  setToken,
  setUid,
  setIsSystem,
  removeToken,
  getCode,
  getUid,
  removeCode,
  removeUid
} from "utils/auth";
import EnvionmentVariables from "../../../baseUrl";
import {
  browserEnvironment,
  linkApp,
  parseTime,
  getUrlParam,
  isWeixin,
  GetDistance
} from "utils/index";
import { CODE_OK } from "utils/publicData";
import { loadBMap } from "utils/BMap";
import areaList from "utils/City";
const wx = require("weixin-js-sdk");
export default {
  name: "freeHealthTest",
  components: {},
  data () {
    return {
      baseImg: EnvionmentVariables.IMAGE_HOST,
      active: 0,
      tabAct: false,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 8, // 每页请求的数量
      total: 0, // 总共的数据条数
      tempGoodList: [],
      areaList: areaList,
      addressShow: false,
      address: "",
      searchWord: "",
      provinceName: "获取",
      cityName: "获取",
      // areaCode: '440305',
      areaCode: "",
      defaultCode: "440300",
      loadingImges: {},
      longitude: "",
      latitude: "",
      token:undefined,
    };
  },
  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff;");
  },
  created () {
    this.token = this.$route.query.appToken;
    // var areaCode = this.$route.query.areaCode;
    // var provinceName = this.$route.query.provinceName;
    // var cityName = this.$route.query.cityName;
    // var district = this.$route.query.district;
    // this.longitude = this.$route.query.longitude;
    // this.latitude = this.$route.query.latitude;
    // let findKey = (value, compare = (a, b) => a === b) => {
    //   return Object.keys(this.areaList.city_list).find((k) =>
    //     compare(this.areaList.city_list[k], value)
    //   );
    // };
    // this.defaultCode = findKey(cityName);
    // let findKeyOne = (value, compare = (a, b) => a === b) => {
    //   return Object.keys(this.areaList.province_list).find((k) =>
    //     compare(this.areaList.province_list[k], value)
    //   );
    // };
    // this.province = findKeyOne(provinceName)
    // console.log(this.defaultCode, 111);
    // console.log("this.$route.query");
    // console.log(this.$route.query);
    // console.log("longitude");
    // console.log(this.longitude);
    // console.log("latitude");
    // console.log(this.latitude);
    // console.log("token");
    // console.log(token);
    // if (token) {
    //   setToken(token);
    // }
    // if (areaCode) {
    //   this.areaCode = areaCode;
    // }
    // if (provinceName) {
    //   this.provinceName = provinceName;
    // }
    // if (cityName) {
    //   this.cityName = cityName;
    // }

    // if (areaCode) {
    //   this.getClubPageByCondtion();
    // } else {
    //   this.init()
    // }
    // this.onlyGetCode();
    // this.init()
    // // 发版本时 注掉下面的代码
    // if (areaCode) {
    //   this.getClubPageByCondtion();
    // }
  },
  mounted () {
    // ios 生成签名要用的
    if (navigator.userAgent.indexOf('iPhone') !== -1) {
      // if (this.$route.query.wechat !== undefined && this.$route.query.wechat === '1') {
        window.wechaturl = window.location + '';
        console.log(" iPhone window.wechaturl")
        console.log(window.wechaturl)
      // }
    }
  },
  methods: {
    c_cancel () {
      this.addressShow = false;
    },
    c_confirm (array) {
      this.address = array[0].name + array[1].name;
      this.cityName = array[1].name;
      this.areaCode = array[1].code;
      this.defaultCode = array[1].code;
      this.addressShow = false;
      this.pageIndex = 1;
      this.tempGoodList = [];
      this.getClubPageByCondtion();
    },
    onHerf () {
      this.$router.push({
        path: "/checkPointPage",
        query: {
          // province: this.province,
          // provinceName: this.provinceName,
          // cityName: this.cityName,
          // defaultCode: this.defaultCode,
          // longitude: this.longitude,
          // latitude: this.latitude,
          token: this.token
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .van-field__control {
  padding-right: 32px;
}
/deep/ .van-cell {
  padding: 0;
  padding-left: 0;
}
/deep/ .van-picker {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 10000;
}
.main {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}
.bgBox{
  flex: 1;
  width: 100%;
  // height:644px;
  // height: 1164px;
  background: url("../../assets/img/checkPoint/background3@2x.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 160px;
  bottom: 0;
  display: flex;
  justify-content: center;
}
.top {
  width: 100%;
  height: 160px;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background: linear-gradient(90deg, #3EABFD 0%, #357DFA 100%);
  // background: rgba(46, 46, 46, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  // top: 36px;
}
.hand_img{
  width: 79px;
  height: 91px;
  position: absolute;
  top: 20px;
  left: 66px;
}
span {
  line-height: 48px;
}
.bottom {
  width: 320px;
  height: 80px;
  line-height: 80px;
  border-radius: 8px;
  font-weight: bold;
  color: #357DFA;
  background: #fff;
  font-size: 32px;
  text-align: center;
  position: fixed;
  bottom: 106px;
}
</style>
